<ng-container *ngIf="!(loading$ | async); else placeholderTpl">
  <div class="form-input" (click)="openOptions()">
    <input
      class="select"
      name=""
      [placeholder]="placeholder"
      type="text"
      [(ngModel)]="value"
      (change)="filterList($event)"
      (blur)="filterList($event)"
      (keyup)="filterList($event)"
      (keypress)="filterList($event)"
      (focus)="filterList($event)"
      [disabled]="disabled"
      autocomplete="off"
      (keydown.enter)="onEnter($event)"
    />
  </div>
  <label class="form-label" for="" [ngClass]="{ focus: value }"> {{ label }} </label>
  <span class="alert" *ngIf="!valueIsValid() && required && change">
    Campo obrigatório
  </span>
  <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg" class="arrow" [ngClass]="{ rotate : optionsShow }">
    <path d="M9 1L5 5L1 1" stroke="black" stroke-width="2"/>
  </svg>

  <div *ngIf="optionsShow && !disabled">
    <div #optionsListElement class="options" [style]="positionRelative ? 'position: inherit;' : ''">
      <div class="option remove-filter" (click)="selectOption({name: '', value: ''})" *ngIf="cleanFilterButton && optionsList.length > 0 && value !== ''">
        Remover Filtro
        <img src="../../../assets/images/icons/filtro.svg" alt="">
      </div>

      <div *ngFor="let option of optionsList; let i = index" class="option" (click)="selectOption(option)">
        {{ option.name }}
      </div>

      <div class="option" *ngIf="optionsList.length === 0" (click)="toggleOptions()">
        Nenhum resultado encontrado
      </div>

      <div class="load-more" *ngIf="loadMoreButton && optionsList.length !== 0">
        <button type="button" (click)="loadMoreOptions()">
          Carregar Mais
          <img src="../../../assets/images/icons/add.svg" alt="">
        </button>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #placeholderTpl>
  <label class="form-label">{{ label }}</label>
  <div class="skeleton-container">
    <div class="skeleton skeleton-input"></div>
  </div>
</ng-template>
